import t from "./ghl-ui.es763.js";
import i from "./ghl-ui.es764.js";
function e(r) {
  return r != null && i(r.length) && !t(r);
}
export {
  e as default
};
